var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "contact-card"
  }, [_c("header", {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: require(`@/assets/images/aboutUS/${_vm.img}`),
      expression: "require(`@/assets/images/aboutUS/${img}`)",
      arg: "background-image"
    }],
    staticClass: "contact-card__header"
  }, [_c("h4", [_vm._v(_vm._s(_vm.title))])]), _c("main", {
    staticClass: "contact-card__main"
  }, [_c("div", {
    staticClass: "cover"
  }, [_c("span", [_vm._v("覆盖：")]), _c("span", [_vm._v(_vm._s(_vm.cover))])]), _c("div", {
    staticClass: "address"
  }, [_c("span", [_vm._v("地址：")]), _c("span", [_vm._v(_vm._s(_vm.address))])]), _c("div", {
    staticClass: "phone"
  }, [_c("span", [_vm._v("电话：")]), _c("span", [_vm._v(_vm._s(_vm.phone))])])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };